import { render, staticRenderFns } from "./Sertif.vue?vue&type=template&id=7daa6e1e"
import script from "./Sertif.vue?vue&type=script&lang=js"
export * from "./Sertif.vue?vue&type=script&lang=js"
import style0 from "./Sertif.vue?vue&type=style&index=0&id=7daa6e1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports